import { ActionsCell } from "../../../Component/Common/Components/DataTable/ActionsCell";
import { DefaultCell } from "../../../Component/Common/Components/DataTable/DefaultCell";
import { Note } from "../../../Component/Model/Dto/Note";
import { DataTableHtmlFormatter, TableDateHelper } from "../../../Component/Model/helpers";
import { ActionType, TableColumn } from "../../../Component/Model/Table/Table";

interface NotesRow {
    Id:                     string;
    CreatedBy:              string;
    Date?:                  string;
    Detail:                 string;
    ActionDate:             string;
    Status:                 string;
    Actions?:               ActionType[];
}

interface NotesTable {
    columns: Array<TableColumn>;
    rows: Array<NotesRow>;
}

export function NotesTableMapper(dataObject: Note.SearchDtoIn[], handleEdit: (id: string) => void, handleDelete: (id: string) => void, handleEmail: (id: string) => void ): NotesTable {
    const columns = [
        { Header: 'Created By', accessor: 'CreatedBy', Cell: ({ value }: any) => <DefaultCell value={value} /> },
        { Header: 'Date', accessor: 'Date', Cell: ({ value }: any) => <DefaultCell value={value}/> },
        { Header: 'Detail', accessor: 'Detail', Cell: ({ value }: any) => <DefaultCell value={value} tooltip={true}/> },
        { Header: 'Action Date', accessor: 'ActionDate', Cell: ({ value }: any) => <DefaultCell value={value}/> },
        { Header: 'Status', accessor: 'Status', Cell: ({ value }: any) => <DefaultCell value={value}/> },
        { Header: 'Actions', accessor: 'Actions', Cell: ({ value }: any) => <ActionsCell actions={value} />, disableSortBy: true },
    ];

    if (dataObject !== undefined && dataObject.length > 0){
        const rows = dataObject.map((item: Note.SearchDtoIn) => ({
            Id: item.Id,
            CreatedBy: item.Username,
            Date: TableDateHelper(item.CreatedDate),
            Detail: DataTableHtmlFormatter(item.NoteText, ' '),
            ActionDate: TableDateHelper(item.ActionDate),
            Status: item.Status === false ? "In Progress": "Completed",
            Actions: item.ResponsibleUser? [
                { label: 'View/Edit', action: handleEdit , key: item.Id, icon: { color: 'info', name: 'edit' } },
                { label: 'Delete', action: handleDelete, key: item.Id, icon: { color: 'error', name: 'delete' } },
                { label: 'Email', action: handleEmail, key: item.Id, icon: { color: 'info', name: 'email' } }] :
            [
                { label: 'View/Edit', action: handleEdit , key: item.Id, icon: { color: 'info', name: 'edit' } },
                { label: 'Delete', action: handleDelete, key: item.Id, icon: { color: 'error', name: 'delete' } }]
        }));

        return { columns: columns, rows: rows };
        
    }else {
        return { columns: columns, rows: [] };
    }
}